var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tags-input__wrapper" },
    [
      _vm._l(_vm.dynamicTags, function (tag, index) {
        return _c(
          "el-tag",
          {
            key: tag + index,
            attrs: {
              type: _vm.tagType,
              closable: true,
              "close-transition": false,
              size: "small",
            },
            on: {
              close: function ($event) {
                return _vm.handleClose(tag)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(tag) + "\n  ")]
        )
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputValue,
            expression: "inputValue",
          },
        ],
        ref: "saveTagInput",
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "Add new tag", size: "mini" },
        domProps: { value: _vm.inputValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.inputValue = $event.target.value
            },
            _vm.onInput,
          ],
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleInputConfirm.apply(null, arguments)
          },
          blur: _vm.handleInputConfirm,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }